<mat-dialog-content class="py-0">
    <form [formGroup]="scheduleForm" (ngSubmit)="submit()">
        <h4 mat-dialog-title class="tx-center" data-testid="schedule-title">График работы</h4>
        <table>
            <tr>
                <th colspan="2"></th>
                <th>Рабочее время</th>
                <th>Обед</th>
            </tr>
            @for ( day of Object.keys(scheduleValues); track day) {
                <tr [formGroupName]="day">
                    <td>{{ daysOfTheWeek[parseInt(day)] }}</td>
                    <td> <input type="checkbox" formControlName="workDay"> </td>
                    <td class="tx-center">
                        <input type="time" formControlName="startWorkTime" data-testid="start-work-time-input">
                        :
                        <input type="time" formControlName="endWorkTime" data-testid="end-work-time-input">
                    </td>
                    <td class="tx-center">
                        <input type="time" formControlName="startLunchTime">
                        :
                        <input type="time" formControlName="endLunchTime">
                    </td>
                </tr>

                @if (day === '1') {
                    <tr>
                        <td colspan="4" class="tx-center">
                            <input type="checkbox" [(ngModel)]="applyToAll" (change)="selectApplyToAll()" [ngModelOptions]="{standalone: true}" data-testid="select-apply-to-all-schedule-input">
                            Применить ко всем
                        </td>
                    </tr>
                }
            }

            <tr>
                <td colspan="4" class="error-field">
                    @if ( scheduleForm.hasError('requireWorkTimes') || scheduleForm.hasError('requireTimes')) {
                        <mat-error>Необходимо указать время начала и окончания рабочего дня</mat-error>
                    }
                    @if ( scheduleForm.hasError('requireLunchTimes') ) {
                        <mat-error>Необходимо указать время начала и окончания обеда</mat-error>
                    }
                </td>
            </tr>
        </table>

        <div class="flex j-space-between mrt-1">
            <button mat-raised-button color="primary" type="button" class="w-40" (click)="close()">Отмена</button>
            <button mat-flat-button color="primary" type="submit" class="w-40" [disabled]="!scheduleForm.valid" data-testid="save-schedule-button">Сохранить</button>
        </div>
    </form>
</mat-dialog-content>
